import { useCallback, useSyncExternalStore } from 'react'

import type { TrackableValue } from './TrackableValue'

export function useTrackableValue<T>(rvalue: TrackableValue<T>): T
export function useTrackableValue<T>(rvalue: TrackableValue<T> | null | undefined): T | null
export function useTrackableValue<T>(rvalue: TrackableValue<T> | null | undefined): T | null {
  return useSyncExternalStore(
    useCallback(
      cb => {
        if (!rvalue) return () => {}
        const subscription = rvalue.listen(cb)
        return () => {
          subscription[Symbol.dispose]()
        }
      },
      [rvalue]
    ),
    () => rvalue?.value ?? null,
    () => rvalue?.value ?? null
  )
}
